import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { ShopV2, ShopV2State, shopV2Store } from './shopV2'
import { ShopV3, ShopV3State, shopV3Store } from './shopV3'

export interface ShopState {
    activityList: IdName[] | null;
    /** 礼品订单列表 */
    giftOrders: {
        [activityId: string]: Shop.GiftOrder[];
    };
    /** 订单详情 */
    orderDetail: {
        [orderId: string]: Shop.OrderDetail;
    };
    changeGift: {
        [orderId: string]: Shop.ChangeGift;
    };
    detail: Shop.Detail | null;
    aftersaleList: Shop.AftersaleList[];
    /** 已发货礼品订单数量 */
    // sentOrderNumber: number;
    v2: ShopV2State;
    v3: ShopV3State;
}

const m: Module<ShopState, RootState> = {
    namespaced: true,
    // @ts-ignore
    state: () => ({
        activityList: null,
        /** 礼品订单列表 */
        giftOrders: {},
        /** 订单详情 */
        orderDetail: {},
        detail: null,
        changeGift: {},
        aftersaleList: [],
    }),
    mutations: {
        /**
         * 获取活动列表
         */
        setActivityList(state, list) {
            state.activityList = list;
        },
        /**
         * 售后详情
         */
        setAftersaleDetail(state, detail) {
            state.detail = detail;
        },
        /**
         * 我的售后
         */
        setAftersaleList(state, aftersaleList) {
            state.aftersaleList = state.aftersaleList.concat(aftersaleList.data);
        },
        resetAftersaleList(state) {
            state.aftersaleList = [];
        },
        /**
         * 设置礼品订单列表和已发货礼品订单数量
         */
        setGiftOrders(state, { activityId, orders }) {
            Vue.set(state.giftOrders, activityId, orders);
        },
        /**
         * 设置订单详情
         */
        setOrderDetail(state, { orderId, order }) {
            Vue.set(state.orderDetail, orderId, order);
        },
        /**
         * 订单详情
         */
        setChangeGift(state, { orderId, geft }) {
            Vue.set(state.changeGift, orderId, geft);
        },
    },
    actions: {
        /**
         * 获取活动列表
         */
        async getActivityList(context) {
            const response = await Vue.axios.get('/api/v1/gift/activity_list');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setActivityList', rdata.data);
            }
            return rdata;
        },
        /**
         *  获取礼品订单列表
         * @param activityId 活动id
         */
        async getGiftOrders({ commit }, { activityId, offset, count }) {
            const response = await Vue.axios.get('/api/v1/gift/orders', {
                params: {
                    activity_id: activityId,
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (response.status === 200) {
                commit('setGiftOrders', { activityId, orders: rdata.data });
            }
        },
        /**
         * 获取订单详情
         */
        async getOrderDetail({ commit }, { orderId }) {
            const response = await Vue.axios.get('/api/v1/gift/order_detail', {
                params: {
                    order_id: orderId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setOrderDetail', { orderId, order: rdata.data });
            }
            return rdata;
        },
        /**
         * 查看可更换的礼品规格
         */
        async getChangeGift({ commit }, { orderId }) {
            const response = await Vue.axios.get('/api/v1/aftersale/get_change_gift', {
                params: {
                    order_id: orderId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setChangeGift', { orderId, geft: rdata.data });
            }
            return rdata;
        },
        /**
         *  申请售后
         */
        async aftersaleApply({ commit }, params) {
            const response = await Vue.axios.post('/api/v1/aftersale/apply', params);
            const rdata = response.data;
            return rdata;
        },
        /**
         *  申请售后
         */
        async applyCancel({ commit }, params) {
            const response = await Vue.axios.post('/api/v1/aftersale/apply_cancel', params);
            const rdata = response.data;
            return rdata;
        },
        /**
         *  填写快递单号
         */
        async addExpressCode({ commit }, params) {
            const response = await Vue.axios.post('/api/v1/aftersale/add_express_code', params);
            const rdata = response.data;
            return rdata;
        },
        /**
         *  售后详情
         */
        async aftersaleDetail({ commit }, params) {
            const response = await Vue.axios.get('/api/v1/aftersale/detail', {params});
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setAftersaleDetail', rdata.data);
            }
            return rdata;
        },
        /**
         *  我的售后
         */
        async getAftersaleList({ commit }, params) {
            const response = await Vue.axios.get('/api/v1/aftersale/index', {params});
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setAftersaleList', rdata.data);
            }
            return rdata;
        },
    },
    modules: {
        v2: shopV2Store,
        v3: shopV3Store,
    }
};

export default m;

